import { useEffect } from "react";

export const Eventos = ({ leadDetails }) => {



    const fetchBitacora = async (idLead) => {
        try {
            const result = await dispatch(extarerEventosPor(idLead)); // Llama a la acción de Redux para obtener la bitácora del lead.
            setBitacora(result); // Almacena los resultados en el estado.
        } catch (error) {
            console.error("Error fetching bitacora:", error); // Maneja cualquier error.
        }
    };

    // Función para obtener el valor de un parámetro específico de la URL.
    const getQueryParam = (param) => {
        // Crea una instancia de 'URLSearchParams' con los parámetros de la URL.
        const value = new URLSearchParams(location.search).get(param);

        // Verifica si el valor es numérico. Si lo es, lo convierte a un número.
        if (value && !isNaN(value) && !isNaN(parseFloat(value))) {
            return Number(value); // Retorna el valor como número.
        }
        return value; // Si no es numérico, retorna el valor original como cadena de texto.
    };

    useEffect(() => {
        // Obtiene los parámetros 'idLead', 'idCalendar', y 'idDate' desde la URL.
        const leadId = getQueryParam("data"); // Extrae el ID del lead desde la URL.

        // Si 'leadId' es válido (mayor que 0), llama a la función para obtener los detalles del lead.
        if (leadId && leadId > 0) {
            fetchLeadDetails(leadId); // Ejecuta la solicitud para obtener los detalles del lead.
            fetchBitacora(leadId); // Ejecuta la solicitud para obtener la bitácora del lead.
        }
    }, [location.search]); // El efecto se ejecuta nuevamente si 'location.search' cambia.

    return (
        <>
            {" "}
            <div className="card">
                <div className="card-header">
                    <h5>Lista de eventos del cliente</h5>
                </div>
                <div className="card-body">
                    <p className="mb-0">Aquí se desglosa todos los eventos relacionado con este cliente</p>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>Eventos</h5>
                </div>
                <div className="card-body">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Nombre Evento</th>
                                <th scope="col">Tipo</th>
                                <th scope="col">Estado</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>Evento 1</td>
                                <td>Reunión</td>
                                <td>Completado</td>
                            </tr>
                            <tr>
                                <td>Evento 1</td>
                                <td>Reunión</td>
                                <td>Completado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};
